import { Pipe, PipeTransform } from '@angular/core';
import { TicketThreadEntryAttachment } from '@zero/shared/util-models';

/**
 * Format the size of a ticket attachment
 */
@Pipe({
  name: 'attachmentSize',
  standalone: true,
})
export class AttachmentSizePipe implements PipeTransform {
  public transform(attachment: TicketThreadEntryAttachment): string {
    if (!attachment) {
      return '0 B';
    }

    if (attachment.attachmentSize > 1000000) {
      return `${Math.round(attachment.attachmentSize / 100000) / 10} MB`;
    } else if (attachment.attachmentSize > 1000) {
      return `${Math.round(attachment.attachmentSize / 100) / 10} kB`;
    } else {
      return `${attachment.attachmentSize} B`;
    }
  }
}
